import { IRectangle, List } from "@fluentui/react";
import { HomePageLinkType, ProductFeatureType, ShortLineModel } from "../../products/models/ProductModel";
import HomeProductItemView from "./HomeProductItemView";

export type HomeProductGridProps = {
    title: string;
    type: HomePageLinkType;
    lines: ShortLineModel[];
    isMobile: boolean;
    onProductDetail: (line: ShortLineModel) => void;
}

export default function HomeProductGridView({ title, type, lines, isMobile, onProductDetail }: HomeProductGridProps) {
    let columnCount: number = 0;
    const phPadding = isMobile ? "ph-10" : "ph-15";

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0 && surfaceRect != null) {
            columnCount = Math.floor(surfaceRect.width / 250);

            if (columnCount <= 1) {
                columnCount = 2;
            }
        }

        return lines.length;
    }

    const onRenderCell = (line?: ShortLineModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const height = 280;

        if (line == null) return <>empty</>;

        return <div
            key={line.id + "-wrapper"}
            className={"list-grid-tile pv-10 " + phPadding}
            data-is-focusable={true}
            style={{ width: width, height: height }}
        >
            <HomeProductItemView
                key={line.id}
                line={line}
                isMobile={isMobile}
                onProductDetail={onProductDetail}
            />
        </div>;
    }

    const onSeeAllClick = () => {
        window.open(`/products?type=${type}`, "_self");
    }

    return <div>
        <div className="pb-20 ph-10">
            <span className="font-large font-bold">{title}</span>
            <div className="pt-8" style={{ float: "right" }}>
                <a onClick={onSeeAllClick}>See All</a>
            </div>
        </div>

        <List
            items={lines}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}